import React from 'react'
import { Box, Grid } from '@chakra-ui/react'
import { Sidebar } from './../../components/SideBar/SideBar'
import { Outlet } from 'react-router-dom'

function SideMenu(): JSX.Element {
  return (
    <Grid templateColumns='272px auto'>
      <Sidebar />
      <Box overflow={'hidden'} height={'100vh'} bg={'greyNeutral100'}>
        <Outlet />
      </Box>
    </Grid>
  )
}

export { SideMenu }
